import Loading from '../../../../Dashboards/Common/Loading';
import { MonthlyEvolutionServices } from './MonthlyEvolutionServices';
import { AnnualEvolutionServices } from './AnnualEvolutionServices';
import { useGeneralResultsChartsDataContext } from './hooks/useGeneralResultsChartsDataContext';

export const Charts = () => {
    const { isLoading } = useGeneralResultsChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <AnnualEvolutionServices />
                <MonthlyEvolutionServices />
            </div>
        </>
    );
};
